var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShowPassword(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "inherit",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 11.3249L1.47815 12.0119C4.23537 15.9736 7.77119 17.9964 12.01 17.9964C16.229 17.9964 19.9367 15.9944 23.0798 12.0653L23.6392 11.3661L23.0057 10.7332C19.8613 7.5915 16.2774 6 12.2989 6C8.32048 6 4.73656 7.5915 1.59213 10.7332L1 11.3249ZM20.93 11.5183C18.2933 14.5239 15.3343 15.9964 12.01 15.9964C8.70164 15.9964 5.92668 14.5395 3.62418 11.5579C5.27256 10.0577 7.02456 9.03626 8.8891 8.48536C8.33306 9.17239 8 10.0473 8 11C8 13.2091 9.79086 15 12 15C14.2091 15 16 13.2091 16 11C16 9.95249 15.5973 8.99902 14.9384 8.28593C17.076 8.76241 19.069 9.83596 20.93 11.5183ZM11 11C11.5523 11 12 10.5523 12 10C12 9.44772 11.5523 9 11 9C10.4477 9 10 9.44772 10 10C10 10.5523 10.4477 11 11 11Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowPassword);
export default __webpack_public_path__ + "static/media/show-password.c65667d64da36e52a2eff683dfbb76f6.svg";
export { ForwardRef as ReactComponent };